:root {
  --sidebar-width: 30rem;
}

.layout {
  display: grid;
  grid-template-rows: minmax(100%, max-content);
  padding-top: var(--header-height);
  width: 100%;
}

/* this CSS class comes from Cutwise Player */
/* iOS Safari doesn't hide layout outside of fullscreen div element */
:global(.cwp-has-fullscreen-element) .layout {
  padding-top: 0;
  height: 100%;
}

.layoutStrictHeight {
  height: 100%;
  position: fixed;
  overflow: hidden;
}

.fullHeight {
  height: 100%;
}

.layoutTwoColumn {
  grid-template-areas: 'sidebar content';
  grid-template-rows: 100%;

  @media (--screen-md-down) {
    grid-template-areas: 'content' !important;
    position: static;
    width: 100%;
  }
}

.layoutWithoutSidebar {
  grid-template-areas: 'content' !important;
  grid-template-columns: 100%;
}

.layoutWithSidebar {
  grid-template-columns: var(--sidebar-width) calc(100% - var(--sidebar-width));

  @media (--screen-md-down) {
    grid-template-columns: 100%;
  }

  @media (--screen-sm-down) {
    grid-template-rows: auto;
  }
}

.layoutOneColumn {
  grid-template-areas: 'content';
  grid-template-columns: 100%;
}
